/**
 * The menu module is responsible for showing and hiding the primary menu on
 * small viewports.
 *
 * @module Menu
 * @requires Velocity
 * @requires Velocity UI
 * @return {Object} public methods
 */

const Menu = (function() {

	var menuLabelElements;
	var menu;
	var bodyElement;
	var width;

	/**
	 * Initializes this module.
	 */
	function init() {
		// Don't even bother when there is no header
		if (document.querySelector('.header') === null) return false;
		if ($('.header.header--shop').length > 0) return false;
		gatherDOMElements();
		addListeners();
		handleMoreDropdownPosition();
	}

	function gatherDOMElements() {
		menuLabelElements = document.querySelectorAll('.is-dropdown');
		menu = document.getElementById('header__navigation');
		bodyElement = document.getElementsByTagName('body')[0];
		width = $(window).width();
	}

	/**
	 * Adds listeners for user actions.
	 */
	function addListeners() {
	        document.getElementById('nav-menu').addEventListener('click', onMenuIconClick, false);
		for (var i = 0; i < menuLabelElements.length; i++) {
			$(menuLabelElements.item(i)).children('a')[0].addEventListener('click', onMenuLabelClick, false);
		}
		var menuBackButtonElements = document.querySelectorAll('.dropdown-back-button');
		for (var j = 0; j < menuBackButtonElements.length; j++) {
			menuBackButtonElements.item(j).addEventListener('click', onMenuBackButtonClick, false);
		}
		window.addEventListener('resize', onWindowResize, false);
	}

	/**
	 * Gets called when the primary menu icon was clicked.
	 * @param {MouseEvent} e
	 * @return {Boolean} false
	 */
	function onMenuIconClick(e) {
		toggleMenu();
		return false;
	}

	/**
	 * Gets called when the menu label is clicked.
	 * @param {MouseEvent} e
	 * @return {Boolean} false
	 */
	function onMenuLabelClick(e) {
		if (!matchMedia('only screen and (min-width: ' + SMF.MAX_WIDTH_CONTENT *  0.8 + 'px)').matches) {
			lockMenuHeight();
			goDown(this);
		}
		return false;
	}

	/**
	 * Gets called when the menu back button is clicked.
	 * @param {MouseEvent} e
	 * @return {Boolean} false
	 */
	function onMenuBackButtonClick(e) {
		lockMenuHeight();
		goUp(this);
	}

	/**
	 * Gets called when the window gets resized.
	 * @param {Event} e
	 */
	function onWindowResize(e) {
		if($(window).width() == width) return false;
		unlockMenuHeight();
		handleMoreDropdownPosition();
		if (matchMedia('only screen and (min-width: ' + SMF.MAX_WIDTH_CONTENT *  0.6 + 'px)').matches) {
			if (matchMedia('only screen and (min-width: ' + SMF.MAX_WIDTH_CONTENT *  0.8 + 'px)').matches) {
				resetMenu();
				showMenu();
				return false;
			}
			resetMenu();
			hideMenu();
			return false;
		}
	}

	/**
	 * Toggles the menu.
	 */
	function toggleMenu() {
		if (!$(menu).hasClass('is-visible')) {
			width = $(window).width();
			lockViewport();
			showMenu();
			resetMenu();
		} else {
			unlockViewport();
			hideMenu();
		}
	}

	/**
	 * Locks the menu to the viewport's height.
	 */
	function hideMenu() {
		removeActiveFlagFromActive();
		// display footer up button
		$('#footer__up').hide();
		menu.style.display = "none";
		$(menu).removeClass('is-visible');
		unlockMenu()
	}

	/**
	 * Unlocks the menu from the viewport's height.
	 */
	function showMenu() {
		removeActiveFlagFromActive();
		// dont display footer up button
		$('#footer__up').hide();
		setActiveFlag('nav-menu');
		menu.style.display = "block";
		$(menu).addClass('is-visible');
		lockMenu();
	}

	/**
	 * Locks the menu to the viewports height.
	 */
	function lockMenu() {
		//menu.style.height = window.innerHeight - 60 + 'px';
	}

	/**
	 * Unlocks the menu from the viewports height.
	 */
	function unlockMenu() {
		//menu.style.height = 'auto';
	}

	/**
	 * Locks the viewport to the viewports height.
	 */
	function lockViewport() {
		//bodyElement.style.height = window.innerHeight + 'px';
		bodyElement.style.overflow = 'hidden';
		bodyElement.style.position = 'fixed';
		lockMenuHeight();
	}

	/**
	 * Unlocks the viewport from the viewports height.
	 */
	function unlockViewport() {
		//bodyElement.style.height = 'auto';
		bodyElement.style.overflow = 'visible';
		bodyElement.style.position = 'inherit';
		unlockMenuHeight();
	}

	/**
	 * Locks the menu hight
	 */
	function lockMenuHeight() {
		//menu.style.height = window.innerHeight - 60 + 'px';
		// scroll to top
		menu.scrollTop = 0;
	}

	/**
	 * Unlock menu hight
	 */
	function unlockMenuHeight() {
		//menu.style.height = 'auto';
		// scroll to top
		menu.scrollTop = 0;
	}

	function goDown(menuLabelElement) {

		var menuElement = document.getElementById('header__navigation').firstElementChild;
		menuLabelElement.nextElementSibling.style.display = 'block';

		$.Velocity(menuElement, {
			left: menuElement.offsetLeft - window.innerWidth
		}, {
			duration: 200,
			complete: function() {
				menuElement.style.left = Math.floor(menuElement.offsetLeft / window.innerWidth) + '00%';
				// contentElement.previousElementSibling.classList.remove('is-animating');
			}
		});
	}

	function goUp(menuBackButtonElement) {

		var menuElement = document.getElementById('header__navigation').firstElementChild;

		if (menuElement.offsetLeft === 0) {
			return false;
		}

		$.Velocity(menuElement, {
			left: menuElement.offsetLeft + window.innerWidth
		}, {
			duration: 200,
			complete: function() {
				menuElement.style.left = Math.floor(menuElement.offsetLeft / window.innerWidth) + '00%';
			}
		});
	}

	/**
	 * Resets the menu to it's initial state.
	 */
	function resetMenu() {

		var menuElement = $('#header__navigation').children('ul')[0];
		var menuFlyoutElements = menuElement.querySelectorAll('.is-dropdown');

		menuElement.style.display = 'block';

		// menuElement.offsetLeft = 0;
		menuElement.style.left = 0;

		if (!matchMedia('only screen and (min-width: ' + SMF.MAX_WIDTH_CONTENT *  0.8 + 'px)').matches) {
			for (var i = 0; i < menuFlyoutElements.length; i++) {
				$(menuFlyoutElements.item(i)).children('ul')[0].style.display = 'none';
			}
		}
	}

	/*
	 * Removes the Active Flag from active menu icon
	 */
	function removeActiveFlagFromActive() {
		$('.header__mobil a.is-active').removeClass('is-active');
	}

	/*
	 * Set active flag for id
	 */
	function setActiveFlag(id) {
		$('#'+id).addClass('is-active');
	}

	/**
	 * More Dropdown should not be outside the page
	 */
	function handleMoreDropdownPosition() {
		var $more= $('.header__sub-navigation .is-dropdown.more');
		var $moreDropdown = $more.find('ul');

		if ($more.length <= 0 || $moreDropdown.length <= 0) return false;

		if ($(window).width() > 940 + 250 ) {
			$moreDropdown.removeClass('keep-in');
		} else {
			if ($more.offset()['left'] + $moreDropdown.outerWidth() + 10 > $(window).width()) {
				$moreDropdown.addClass('keep-in');
			} else {
				$moreDropdown.removeClass('keep-in');
			}
		}
	}

	// Public methods
	return {
		init: init
	};

})();

window.Menu = Menu;
export default Menu;
